import Add2Cart from './add';
import AddFreeTrial from './add-trial';
import Trial2paid from './trial2paid';
import { flowTypes } from '../../constant';

export default {
  [flowTypes.addTrial]: AddFreeTrial,
  [flowTypes.trial2paid]: Trial2paid,
  [flowTypes.add2cart]: Add2Cart,
};
